/**
 * @ngdoc service
 * @name proximus.core.language.service:LanguageService
 * @description
 * # LanguageService
 *  Is used to provide the selected language
 */
export default class LanguageService {
    constructor(configurationService) {
        this.configurationService = configurationService;
    }
    getSelectedLanguage() {
        return this.configurationService.getSelectedLanguage() || 'en';
    }
}
